import { RemoveCircleAlternate } from '../streamlineSolidIcon/RemoveCircleAlternate';
import { StandardButton, type StandardButtonProps } from './StandardButton';

export interface DeleteButtonProps
  extends Omit<StandardButtonProps, 'startIcon' | 'endIcon'> {}

export const DeleteButton = ({ text, size, ...props }: DeleteButtonProps) => (
  <StandardButton
    variant="contained"
    color="error"
    text={text || 'Delete'}
    startIcon={<RemoveCircleAlternate />}
    size={size}
    {...props}
  />
);
